<section class="manage-users-page">

  @if (toast()) {
    <div class="toast-message error" role="status">
      {{ toast()?.message }}
    </div>
  }

  <div class="config-card users-list">
    <div class="toolbar topbar">
      <div class="toolbar-left">
        <label class="page-size-box">
          <span>Show</span>
          <select [value]="pageSize()" (change)="onPageSizeChange($any($event.target).value)">
            <option [value]="10">10</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
          </select>
        </label>

        <label class="search-box">
          <span>Search</span>
          <input type="search" placeholder="search..." (input)="onSearch($any($event.target).value)">
        </label>
      </div>

      <div class="filter-row">
        <label class="search-box">
          <span>Stakeholder Type</span>
          <select [formControl]="filterForm.controls.entity_type" (change)="onFilterChange()">
            <option value="ALL">All</option>
            <option value="QCA_REGISTRATION">QCA</option>
            <option value="UTILITY_REGISTRATION">Utility</option>
            <option value="GENERATING_COMPANY">Generation Company</option>
            <option value="PSS_OWNER">PSS Owner</option>
          </select>
        </label>

        <label class="search-box">
          <span>Status</span>
          <select [formControl]="filterForm.controls.status" (change)="onFilterChange()">
            <option value="ALL">All</option>
            <option value="SUBMITTED">Submitted</option>
            <option value="APPROVED">Approved</option>
            <option value="REJECTED">Rejected</option>
            <option value="DRAFT">Draft</option>
          </select>
        </label>
      </div>
    </div>

    <div class="table-wrap">
      <table class="table-sm privilege-table">
        <tr>
          <th>#</th>
          <th>Reference No.</th>
          <th>Username</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Stakeholder</th>
          <th>Status</th>
          <th>Submitted On</th>
          <th>Action</th>
        </tr>
        @for (registration of paginatedRegistrations(); track registration.id; let index = $index) {
          <tr [class.selected-row]="isRowSelected(registration.id)">
            <td>{{ (currentPage() - 1) * pageSize() + index + 1 }}</td>
            <td>{{ registration.registration_no }}</td>
            <td>{{ registration.username }}</td>
            <td>{{ registration.email }}</td>
            <td>{{ registration.mobile || '-' }}</td>
            <td>{{ entityLabel(registration.entity_type) }}</td>
            <td>
              <span class="status-pill" [ngClass]="statusClass(registration.status)">{{ statusLabel(registration.status) }}</span>
            </td>
            <td>{{ formatDateTime(registration.created_on) }}</td>
            <td>
              <button type="button" class="dots-button" (click)="openRowActions(registration.id, $event)" aria-label="Open actions">⋮</button>
              @if (openActionMenuId() === registration.id) {
                <div class="action-menu" [style.top.px]="actionMenuPosition().top" [style.left.px]="actionMenuPosition().left">
                  <button type="button" (click)="openRegistration(registration)"><span>👁</span>View</button>
                </div>
              }
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="10">No registration requests found.</td>
          </tr>
        }
      </table>
    </div>

    @if (filteredRegistrations().length === 0) {
      <div class="empty-state">No registration requests match the selected filters.</div>
    }

    @if (filteredRegistrations().length > 0) {
      <div class="pagination">
        <span>Showing {{ paginatedRegistrations().length }} of {{ filteredRegistrations().length }} Results</span>
        <div>
          <button type="button" class="pagination-arrow" [disabled]="currentPage() === 1" (click)="prevPage()">‹</button>
          @for (page of pageNumbers(); track page) {
            <button
              type="button"
              class="pagination-page"
              [class.active]="currentPage() === page"
              (click)="goToPage(page)"
            >
              {{ page }}
            </button>
          }
          <button type="button" class="pagination-arrow" [disabled]="currentPage() === totalPages()" (click)="nextPage()">›</button>
        </div>
      </div>
    }
  </div>

  @if (selectedRegistration()) {
    <div class="modal-backdrop" role="presentation">
      <div class="review-modal" role="dialog" aria-modal="true" aria-labelledby="registration-review-title">
        @if (isQcaRegistration(selectedRegistration())) {
          <div class="form-shell">
            <div class="modal-title-row">
              <div>
                <p>{{ entityLabel(selectedRegistration()!.entity_type) }} Registration</p>
                <h2 id="registration-review-title">{{ selectedRegistration()!.registration_no }}</h2>
              </div>
              <span class="status-pill" [ngClass]="statusClass(selectedRegistration()!.status)">{{ statusLabel(selectedRegistration()!.status) }}</span>
            </div>

            <section class="form-card">
              <header class="form-card__header">Basic Information</header>
              <div class="form-grid">
                <div class="field-box">
                  <label>QCA Name</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'qca_name')) }}</span>
                </div>
                <div class="field-box">
                  <label>Username</label>
                  <span>{{ formatValue(selectedRegistration()!.username) }}</span>
                </div>
                <div class="field-box">
                  <label>Registration Number</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'registration_number')) }}</span>
                </div>
                <div class="field-box">
                  <label>PSS Selection</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'pss_selection')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">QCA Address</header>
              <div class="form-grid">
                <div class="field-box field-box--full">
                  <label>Address Line 1</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'address_line1')) }}</span>
                </div>
                <div class="field-box">
                  <label>Address Line 2</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'address_line2')) }}</span>
                </div>
                <div class="field-box">
                  <label>City / Town</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'city_town')) }}</span>
                </div>
                <div class="field-box">
                  <label>District</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'district')) }}</span>
                </div>
                <div class="field-box">
                  <label>State</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'state')) }}</span>
                </div>
                <div class="field-box">
                  <label>Pin Code</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'pin_code')) }}</span>
                </div>
                <div class="field-box">
                  <label>Country</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'country')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">Control Room Details</header>
              <div class="form-grid">
                <div class="field-box">
                  <label>Control Room Contact No.</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'control_room_contact_no')) }}</span>
                </div>
                <div class="field-box">
                  <label>Control Room Mobile</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'control_room_mobile')) }}</span>
                </div>
                <div class="field-box">
                  <label>Control Room Email</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'control_room_email')) }}</span>
                </div>
                <div class="field-box">
                  <label>Control Room Fax</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'control_room_fax')) }}</span>
                </div>
                <div class="field-box field-box--full">
                  <label>Control Room Address</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'control_room_address')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">Nodal Officer Details</header>
              <div class="form-grid">
                <div class="field-box">
                  <label>Full Name</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'nodal_full_name')) }}</span>
                </div>
                <div class="field-box">
                  <label>Designation</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'nodal_designation')) }}</span>
                </div>
                <div class="field-box">
                  <label>Mobile Number</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'nodal_mobile_number')) }}</span>
                </div>
                <div class="field-box">
                  <label>Email Address</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'nodal_email_address')) }}</span>
                </div>
                <div class="field-box">
                  <label>Alternate Mobile</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'nodal_alternate_mobile')) }}</span>
                </div>
                <div class="field-box">
                  <label>Alternate Email</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'nodal_alternate_email')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">Alternate Nodal Officer</header>
              <div class="form-grid">
                <div class="field-box">
                  <label>Full Name</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'alternate_full_name')) }}</span>
                </div>
                <div class="field-box">
                  <label>Designation</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'alternate_designation')) }}</span>
                </div>
                <div class="field-box">
                  <label>Mobile Number</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'alternate_mobile_number')) }}</span>
                </div>
                <div class="field-box">
                  <label>Email Address</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'alternate_email_address')) }}</span>
                </div>
              </div>
            </section>

          </div>
        } @else if (isPssRegistration(selectedRegistration())) {
          <div class="form-shell">
            <div class="modal-title-row">
              <div>
                <p>{{ entityLabel(selectedRegistration()!.entity_type) }} Registration</p>
                <h2 id="registration-review-title">{{ selectedRegistration()!.registration_no }}</h2>
              </div>
              <span class="status-pill" [ngClass]="statusClass(selectedRegistration()!.status)">{{ statusLabel(selectedRegistration()!.status) }}</span>
            </div>

            <section class="form-card">
              <header class="form-card__header">Basic Information</header>
              <div class="form-grid">
                <div class="field-box">
                  <label>PSS Owner Name</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'pss_owner_name')) }}</span>
                </div>
                <div class="field-box">
                  <label>Username</label>
                  <span>{{ formatValue(selectedRegistration()!.username) }}</span>
                </div>
                <div class="field-box">
                  <label>PSS Name</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'pss_name')) }}</span>
                </div>
                <div class="field-box">
                  <label>PSS Code</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'pss_code')) }}</span>
                </div>
                <div class="field-box">
                  <label>Voltage Level</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'voltage_level')) }}</span>
                </div>
                <div class="field-box">
                  <label>Grid Interconnection Type</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'grid_interconnection_type')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">PSS Location & Address</header>
              <div class="form-grid">
                <div class="field-box field-box--full">
                  <label>Address Line 1</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'address_line1')) }}</span>
                </div>
                <div class="field-box">
                  <label>Address Line 2</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'address_line2')) }}</span>
                </div>
                <div class="field-box">
                  <label>City / Town</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'city_town')) }}</span>
                </div>
                <div class="field-box">
                  <label>District</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'district')) }}</span>
                </div>
                <div class="field-box">
                  <label>State</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'state')) }}</span>
                </div>
                <div class="field-box">
                  <label>Pin Code</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'pin_code')) }}</span>
                </div>
                <div class="field-box">
                  <label>Country</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'country')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">Contact Person Details</header>
              <div class="form-grid">
                <div class="field-box">
                  <label>Contact Person Name</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'contact_person_name')) }}</span>
                </div>
                <div class="field-box">
                  <label>Designation</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'designation')) }}</span>
                </div>
                <div class="field-box">
                  <label>Mobile Number</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'mobile_number')) }}</span>
                </div>
                <div class="field-box">
                  <label>Email Address</label>
                  <span>{{ formatValue(payloadValue(selectedRegistration(), 'email_address')) }}</span>
                </div>
              </div>
            </section>

            <section class="form-card">
              <header class="form-card__header">Document Upload</header>
              <div class="form-grid">
                @for (document of selectedRegistration()!.documents; track document.id) {
                  <div class="field-box">
                    <label>{{ document.document_type }}</label>
                    <span>{{ document.file_name }}</span>
                  </div>
                } @empty {
                  <div class="field-box field-box--full">
                    <span>No attachments uploaded.</span>
                  </div>
                }
              </div>
            </section>
          </div>
        } @else {
          <div class="modal-title-row">
            <div>
              <p>{{ entityLabel(selectedRegistration()!.entity_type) }} Registration</p>
              <h2 id="registration-review-title">{{ selectedRegistration()!.registration_no }}</h2>
            </div>
            <span class="status-pill" [ngClass]="statusClass(selectedRegistration()!.status)">{{ statusLabel(selectedRegistration()!.status) }}</span>
          </div>

          <div class="modal-header">
            <div>
              <p>Registration Details</p>
              <span>Review the submitted information below.</span>
            </div>
            <button type="button" class="icon-button" (click)="closeRegistration()" aria-label="Close review modal">×</button>
          </div>

          <div class="review-meta">
            <div><strong>Username</strong><span>{{ selectedRegistration()!.username }}</span></div>
            <div><strong>Email</strong><span>{{ selectedRegistration()!.email }}</span></div>
            <div><strong>Phone</strong><span>{{ selectedRegistration()!.mobile || '-' }}</span></div>
            <div><strong>Status</strong><span class="status-pill" [ngClass]="statusClass(selectedRegistration()!.status)">{{ statusLabel(selectedRegistration()!.status) }}</span></div>
          </div>

          <div class="review-grid">
            @for (entry of payloadEntries(selectedRegistration()!); track entry[0]) {
              <div class="review-field">
                <strong>{{ labelFromKey(entry[0]) }}</strong>
                <span>{{ formatListValue(entry[1]) }}</span>
              </div>
            }
          </div>
        }

        @if (selectedRegistration()!.status === 'SUBMITTED') {
          <label class="remarks-box">
            <span>Remarks</span>
            <textarea rows="3" [value]="reviewRemarks()" (input)="reviewRemarks.set($any($event.target).value)" placeholder="Add approval or rejection remarks"></textarea>
          </label>

          <div class="modal-actions">
            <button type="button" class="approve-btn" [disabled]="isReviewBusy()" (click)="approveSelected()">Approve</button>
            <button type="button" class="reject-btn" [disabled]="isReviewBusy()" (click)="rejectSelected()">Reject</button>
            <button type="button" class="secondary-button" (click)="closeRegistration()">Cancel</button>
          </div>
        } @else {
          <div class="modal-actions">
            <button type="button" class="secondary-button" (click)="closeRegistration()">Close</button>
          </div>
        }
      </div>
    </div>
  }
</section>
